export default {
  slots: {
    identity: {
      label: "Pièce d'identité",
      hint: "Carte d'identité, passeport ou titre de séjour, recto et verso. Les pièces d'identité de vos associés vont ici aussi.",
    },
    trade_registration: {
      label: "Immatriculation d'entreprise (Gewerbeanmeldung)",
      hint: "L'immatriculation d'entreprise reçue de votre office de commerce.",
    },
    commercial_register_extract: {
      label: 'Extrait du registre du commerce (Handelsregisterauszug)',
      hint: 'Un extrait récent du registre du commerce, si votre entreprise y est inscrite.',
    },
    bank_statement: {
      label: 'Relevé bancaire (Kontoauszug)',
      hint: "Un relevé récent de votre compte professionnel indiquant le titulaire du compte et l'IBAN.",
    },
    shareholder_list: {
      label: 'Liste des associés (Gesellschafterliste)',
      hint: 'La liste actuelle des associés.',
      hint_gbr: 'Votre contrat de société (Gesellschaftsvertrag) ou une liste de tous les associés.',
    },
    tax_number: {
      label: 'Numéro fiscal ou numéro de TVA (Steuernummer oder USt-IdNr.)',
      hint: 'Un courrier du centre des impôts indiquant votre numéro fiscal, ou la confirmation de votre numéro de TVA.',
    },
  },
  tags: {
    required: 'Obligatoire',
    optional: 'Facultatif',
    missing: 'Manquant',
  },
  kinds: {
    passport: 'Passeport',
    driver_license: 'Permis de conduire',
    id_card: "Carte d'identité",
    residence_permit: 'Titre de séjour',
  },
  holders: {
    owner: 'Propriétaire',
    partner: 'Associé : {{name}}',
  },
  file: {
    with_back: 'Recto et verso',
    uploaded_at: 'Téléversé le {{date}}',
    expires_at: "Valable jusqu'au {{date}}",
  },
  errors: {
    load: 'Impossible de charger les documents.',
  },
  empty: "Aucun fichier pour l'instant",
  buttons: {
    add: 'Ajouter un fichier',
    replace: 'Remplacer',
    remove: 'Supprimer',
    retry: 'Réessayer',
  },
  remove_confirm: {
    title: 'Supprimer ce fichier ?',
    description: 'À utiliser si vous avez téléversé un fichier par erreur.',
    ok: 'Supprimer',
    cancel: 'Annuler',
  },
  toasts: {
    remove_success: 'Fichier supprimé',
    remove_error: "Le fichier n'a pas pu être supprimé. Veuillez réessayer.",
  },
};
